<div class="eiq-interactive-dropdown">
  <button mat-icon-button class="eiq-interactive-dropdown__button left-button" [disabled]="order() === 1" (click)="clicked.emit(order() - 1)">
    <fa-icon [icon]="faChevronLeft"></fa-icon>
  </button>
  <button [matMenuTriggerFor]="menu" mat-button class="eiq-interactive-dropdown__button menu-button">
    <ng-content select="[slot=label]"></ng-content>
  </button>
  <mat-menu #menu="matMenu" class="eiq-interactive-mat-menu">
    <ng-content select="[slot=menuItems]"></ng-content>
  </mat-menu>
  <button mat-icon-button class="eiq-interactive-dropdown__button right-button" [disabled]="itemCount() === order()" (click)="clicked.emit(order() + 1)">
    <fa-icon [icon]="faChevronRight"></fa-icon>
  </button>
</div>
